import React from 'react';
import style from './logoNoLinkTransparent.module.scss';
import logoImage from 'acscp/assets/logoDesktopTransparent.png';

export const LogoNoLinkTransparent: React.FC = () => (
    <img className={style.Logo} src={logoImage} />
);
